// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Qmnb","left":"_3SmDr","right":"_32qCd","small":"_22Kp2","normal":"_1wgvY"};